// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const TICK_LENGTH = 8;
export const TICK_MARGIN = 4;
export const TICK_LINE_HEIGHT = 16;
export const X_TICK_COUNT_RATIO = 100;
export const Y_TICK_COUNT_RATIO = 50;



// WEBPACK FOOTER //
// /local/home/vibhorbh/src/internal/components/cartesian-chart/constants.ts